@switch (slot.widget?.viewType) {
  @case (formType.BUSINESS_REGISTRATION_FORM) {
    <business-registration-dynamic-form
      [slot]="slot"
      [actionEvent]="actionEvent"
    ></business-registration-dynamic-form>
  }
  @case (formType.FEEDBACK_FORM) {
    <feedback-form [slot]="slot" [actionEvent]="actionEvent"></feedback-form>
  }
  @case (formType.IB_CREDIT_FORM) {
    <ib-credit-form [slot]="slot" [actionEvent]="actionEvent"></ib-credit-form>
  }
}
